// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YFx9p","right":"styles_right__2pkvC"};